export default [{
    name: 'question',
    path: '/question',
    component: () => import('@/views/question')
},
    {
        path: '/preview', // 预览页面路由地址
        name: 'Preview',
        props: route => ({
            form: JSON.parse(route.query.form || '{}') // 接收URL参数并转为对象
        }),
        component: () => import('@/views/question/dialog/index.vue')
    },
{
    path: '/question/add',
    component: () => import('@/views/question/add')
},
{
    path: '/question/:id',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/question/detail')
},
{
    path: '/question/:id/edit',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/question/edit')
},
    {
        path: '/question/:id/copy',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/question/copy')
    },
]